import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { requestConfirm } from '../actions/modal-actions';

const useRequestConfirm = () => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => dispatch(requestConfirm(...args)),
    [dispatch],
  );
};

export default useRequestConfirm;
